import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d96fc21"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "label-large related-services__title"
}
const _hoisted_2 = { class: "related-services__button-wrapper" }
const _hoisted_3 = { class: "related-services__cards" }

import RelatedServiceResultCard from '@/components/public/RelatedServiceResultCard.vue'
import { Availability, OrderItemReferral } from '@/models/public/order.model'
import { RelatedService } from '@/models/public/service.model'
import BaseButton from '../BaseButton.vue'
import { computed, PropType, reactive, ref } from 'vue'
import { FORMATS } from '@/enums/components'

enum SCROLL_DIRECTION {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RelatedServices',
  props: {
  title: {
    type: String as PropType<string | undefined>,
    default: undefined,
  },
  services: {
    type: Array as PropType<RelatedService[]>,
    default: () => [],
  },
  isPreview: {
    type: Boolean,
    default: false,
  },
  referral: {
    type: Object as PropType<OrderItemReferral | undefined>,
    default: undefined,
  },
},
  setup(__props) {

const props = __props



const relatedServicesScroller = ref<HTMLInputElement | null>(null)
const availabilitySearchInSession = computed<Availability | null>(() => {
  const searchInsession = sessionStorage.getItem('availiability-search')
  return searchInsession ? JSON.parse(searchInsession) : null
})

const availabilityPayload = reactive<Availability>(
  availabilitySearchInSession.value
    ? { ...availabilitySearchInSession.value }
    : {
        check_in: null,
        check_out: null,
        adults: 0,
        children: 0,
        quantity: 1,
        validate_fields: false,
      },
)

const relatedServicesCardsWidth = computed<number>(() => {
  const cardWidth = 282
  const gapWidth = 16
  return props.services?.length * (cardWidth + gapWidth) || 0
})

const showScrollButtons = computed<boolean>(
  () =>
    (relatedServicesScroller.value &&
      relatedServicesCardsWidth.value >
        relatedServicesScroller.value.clientWidth) ||
    false,
)

function scroll(direction: SCROLL_DIRECTION) {
  if (direction === SCROLL_DIRECTION.LEFT) {
    if (relatedServicesScroller.value) {
      relatedServicesScroller.value.scrollLeft =
        relatedServicesScroller.value.scrollLeft -
        relatedServicesScroller.value?.clientWidth
    }
  } else if (direction === SCROLL_DIRECTION.RIGHT) {
    if (relatedServicesScroller.value) {
      relatedServicesScroller.value.scrollLeft =
        relatedServicesScroller.value.scrollLeft +
        relatedServicesScroller.value?.clientWidth
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["related-services wrapper", { 'related-services--preview': __props.isPreview }])
  }, [
    (__props.title)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_1, _toDisplayString(__props.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_unref(showScrollButtons))
        ? (_openBlock(), _createBlock(BaseButton, {
            key: 0,
            icon: "chevron-left",
            format: _unref(FORMATS).PRIMARY,
            "icon-size": 40,
            class: "related-services__button related-services__button--left hide-mobile",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (scroll(SCROLL_DIRECTION.LEFT)))
          }, null, 8, ["format"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        ref_key: "relatedServicesScroller",
        ref: relatedServicesScroller,
        class: _normalizeClass(["related-services__scroller", { 'related-services__scroller--preview': __props.isPreview }])
      }, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.services, (item) => {
            return (_openBlock(), _createBlock(RelatedServiceResultCard, {
              key: item.id,
              "related-service": item,
              "is-preview": __props.isPreview,
              "availability-request": availabilityPayload,
              referral: __props.referral
            }, null, 8, ["related-service", "is-preview", "availability-request", "referral"]))
          }), 128))
        ])
      ], 2),
      (_unref(showScrollButtons))
        ? (_openBlock(), _createBlock(BaseButton, {
            key: 1,
            icon: "chevron-right",
            "icon-size": 40,
            class: "related-services__button related-services__button--right hide-mobile",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (scroll(SCROLL_DIRECTION.RIGHT)))
          }))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})